/**
 * 统一管理所有的环境值
 *
 * @since 1.0.0
 * @version 1.1.0
 */

/**
 * 静态资源CDN
 *
 * @enum
 *
 * @readonly
 */
const CDN_HOST = {
  development: 'https://mpm-front-test.oss-cn-hangzhou.aliyuncs.com',
  test: 'https://mpm-front-test.oss-cn-hangzhou.aliyuncs.com',
  test2: 'https://mpm-front-test.oss-cn-hangzhou.aliyuncs.com',
  release: 'https://mpm-front.oss-cn-hangzhou.aliyuncs.com',
  prod: 'https://mpm-front.yunyiku.com.cn',
}

/**
 * 下载excel 模板
 *
 * @enum
 *
 * @readonly
 */
const EXCEL_HOST = {
  development: 'http://panshi-ceshi.oss-cn-hangzhou.aliyuncs.com',
  test: 'http://panshi-ceshi.oss-cn-hangzhou.aliyuncs.com',
  test2: 'http://panshi-ceshi.oss-cn-hangzhou.aliyuncs.com',
  release: 'http://panshi-on.oss-cn-hangzhou.aliyuncs.com',
  prod: 'http://panshi-on.oss-cn-hangzhou.aliyuncs.com',
}

/**
 * image组件自动附加OSS参数的CDN前缀列表
 *
 * @type {string[]}
 */
const OSS_CDN_HOST_LIST = [
  'images.yunyiku.com.cn',
  'mpm-front.yunyiku.com.cn',
  'mpm-front-test.yunyiku.com.cn',
  'images.meipingmi.com.cn',
  'mpm-front.meipingmi.com.cn',
  'mpm-front-test.meipingmi.com.cn',
  'aliyuncs.com',
]

/**
 * 商品图片资源CDN
 *
 * @enum
 *
 * @readonly
 */
const UPLOAD_CDN_HOST = {
  development: 'https://panshi-ceshi.meipingmi.com.cn/',
  test: 'https://panshi-ceshi.meipingmi.com.cn/',
  test2: 'https://panshi-ceshi.meipingmi.com.cn/',
  release: 'https://panshi-on.meipingmi.com.cn/',
  prod: 'https://panshi-on.meipingmi.com.cn/',
}

/**
 * 不同环境对应不同上传服务
 * @type {{development: string, test: string, test2: string, release: string, prod: string}}
 */
const FILE_BUCKET = {
  development: 'panshi-ceshi',
  test: 'panshi-ceshi',
  test2: 'panshi-ceshi',
  prod: 'panshi-on',
  release: 'panshi-on',
}

/**
 * 业务文件上传
 * @type {{VUE_OSS_FILE_BUCKET: *, VUE_OSS_REGION: *, VUE_OSS_KEY_ID: *, VUE_OSS_KEY_SECRET: *}}
 */
const OSS_FILE = {
  OSS_KEY_ID: 'LTAIa2dE04R5knjA',
  OSS_KEY_SECRET: 'SIod0RrxZBJF8oy8kEhzn15Tdxnwr7',
  OSS_REGION: 'oss-cn-hangzhou',
  OSS_BUCKET: FILE_BUCKET[process.env.VUE_APP_SERVER_ENV],
}

export { CDN_HOST }
export { EXCEL_HOST }
export { UPLOAD_CDN_HOST }
export { OSS_CDN_HOST_LIST }
export { OSS_FILE }
